import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Layout from '@/layout'

export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [{
      path: 'dashboard',
      name: 'Dashboard',
      component: () => import('@/views/dashboard/index'),
      meta: { title: '数据概览', icon: 'el-icon-data-line' }
    }]
  },
  {
    path: '/regional',
    component: Layout,
    redirect: '/regional/map',
    children: [{
      path: 'map',
      name: 'RegionalMap',
      component: () => import('@/views/dashboard/regional-map'),
      meta: { title: '城市动态地图', icon: 'el-icon-map-location' }
    }]
  },
  {
    path: '/customers',
    component: Layout,
    redirect: '/customers/list',
    name: 'Customers',
    meta: { title: '货主管理', icon: 'el-icon-user' },
    children: [
      {
        path: 'list',
        name: 'CustomerList',
        component: () => import('@/views/customers/list'),
        meta: { title: '货主列表', icon: 'el-icon-user' }
      },
      {
        path: 'pending',
        name: 'CustomerPending',
        component: () => import('@/views/customers/pending'),
        meta: { title: '待审用户', icon: 'el-icon-user-solid' }
      }
    ]
  },
  {
    path: '/drivers',
    component: Layout,
    redirect: '/drivers/list',
    name: 'Drivers',
    meta: { title: '车主管理', icon: 'el-icon-truck' },
    children: [
      {
        path: 'list',
        name: 'DriverList',
        component: () => import('@/views/drivers/list'),
        meta: { title: '车主列表', icon: 'el-icon-truck' }
      },
      {
        path: 'pending',
        name: 'DriverPending',
        component: () => import('@/views/drivers/pending'),
        meta: { title: '待审车主', icon: 'el-icon-warning' }
      }
    ]
  },
  {
    path: '/loaders',
    component: Layout,
    redirect: '/loaders/list',
    name: 'Loaders',
    meta: { title: '装卸管理', icon: 'icon-forklift' },
    children: [
      {
        path: 'list',
        name: 'LoaderList',
        component: () => import('@/views/loaders/list'),
        meta: { title: '装卸列表', icon: 'icon-forklift' }
      },
      {
        path: 'pending',
        name: 'LoaderPending',
        component: () => import('@/views/loaders/pending'),
        meta: { title: '待审装卸', icon: 'el-icon-warning' }
      }
    ]
  },
  {
    path: '/orders',
    component: Layout,
    redirect: '/orders/customer',
    name: 'Orders',
    meta: { title: '订单管理', icon: 'el-icon-s-order' },
    children: [
      {
        path: 'customer',
        name: 'CustomerOrders',
        component: () => import('@/views/orders/customer-orders'),
        meta: { title: '货主订单', icon: 'el-icon-user' }
      },
      {
        path: 'driver',
        name: 'DriverOrders',
        component: () => import('@/views/orders/driver-orders'),
        meta: { title: '车主订单', icon: 'el-icon-truck' }
      },
      {
        path: 'loader',
        name: 'LoaderOrders',
        component: () => import('@/views/orders/loader-orders'),
        meta: { title: '装卸订单', icon: 'icon-forklift' }
      }
    ]
  },
  {
    path: '/services',
    component: Layout,
    redirect: '/services/list',
    name: 'Services',
    meta: { title: '拓展服务', icon: 'el-icon-set-up' },
    children: [
      {
        path: 'list',
        name: 'ServiceMerchantList',
        component: () => import('@/views/services/list'),
        meta: { title: '商家列表', icon: 'el-icon-s-shop' }
      },
      {
        path: 'merchants',
        name: 'ServiceMerchants',
        component: () => import('@/views/services/merchants'),
        meta: { title: '商家入驻审核', icon: 'el-icon-shop' }
      },
      {
        path: 'orders',
        name: 'ServiceOrders',
        component: () => import('@/views/services/orders'),
        meta: { title: '服务订单', icon: 'el-icon-tickets' }
      }
    ]
  },
  {
    path: '/statistics',
    component: Layout,
    children: [
      {
        path: '',
        name: 'OrderStatistics',
        component: () => import('@/views/orders/statistics'),
        meta: { title: '订单统计', icon: 'el-icon-pie-chart' }
      }
    ]
  },
  {
    path: '/finance',
    component: Layout,
    redirect: '/finance/transactions-customer',
    name: 'Finance',
    meta: { title: '财务管理', icon: 'el-icon-money' },
    children: [
      {
        path: 'transactions-customer',
        name: 'TransactionsCustomer',
        component: () => import('@/views/finance/transactions-customer'),
        meta: { title: '货主交易', icon: 'el-icon-user' }
      },
      {
        path: 'transactions-driver',
        name: 'TransactionsDriver',
        component: () => import('@/views/finance/transactions-driver'),
        meta: { title: '车主交易', icon: 'el-icon-truck' }
      },
      {
        path: 'transactions-loader',
        name: 'TransactionsLoader',
        component: () => import('@/views/finance/transactions-loader'),
        meta: { title: '装卸交易', icon: 'icon-forklift' }
      },
      {
        path: 'withdrawals-customer',
        name: 'WithdrawalsCustomer',
        component: () => import('@/views/finance/withdrawals-customer'),
        meta: { title: '货主充值和提现', icon: 'el-icon-user' }
      },
      {
        path: 'withdrawals-driver',
        name: 'WithdrawalsDriver',
        component: () => import('@/views/finance/withdrawals-driver'),
        meta: { title: '车主提现', icon: 'el-icon-truck' }
      },
      {
        path: 'withdrawals-loader',
        name: 'WithdrawalsLoader',
        component: () => import('@/views/finance/withdrawals-loader'),
        meta: { title: '装卸提现', icon: 'icon-forklift' }
      }
    ]
  },
  {
    path: '/customer-service',
    component: Layout,
    children: [
      {
        path: 'index',
        name: 'CustomerService',
        component: () => import('@/views/customer-service/index'),
        meta: { title: '客服消息', icon: 'el-icon-service' }
      }
    ]
  },
  {
    path: '/a-number-reports',
    component: Layout,
    children: [
      {
        path: '',
        name: 'ANumberReports',
        component: () => import('@/views/system/a-number-reports'),
        meta: { title: 'A号码报备', icon: 'el-icon-phone-outline' }
      }
    ]
  },
  {
    path: '/system',
    component: Layout,
    redirect: '/system/messages',
    name: 'System',
    hidden: true, // 隐藏「系统管理→消息管理」菜单（路由保留，直接访问 URL 仍可用）
    meta: { title: '系统管理', icon: 'el-icon-setting' },
    children: [
      {
        path: 'messages',
        name: 'Messages',
        component: () => import('@/views/system/messages'),
        meta: { title: '消息管理', icon: 'el-icon-chat-dot-round' }
      }
    ]
  },
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router
